import api from "@/utils/api.util";

export class FileService {
  static RESOURCE = "/files/";

  static all(params = {}) {
    return api.get(this.RESOURCE, { params });
  }

  static create(data = {}) {
    return api.post(this.RESOURCE, data);
  }

  static download(id, filename = "photo.jpg") {
    // return api.get(this.RESOURCE + id).then((response) => {
    //   const data = response.data.data;
    //   const url = data.attributes.url;
    //   const filename_arr = data.attributes.filename.split("/");
    //   const filename = filename_arr[filename_arr.length - 1];

    //   const link = document.createElement("a");
    //   link.download = filename;
    //   link.href = url;
    //   link.click();
    // });

    const filename_arr = filename.split("/");
    const name = filename_arr[filename_arr.length - 1];

    return api
      .get(this.RESOURCE + id + "/download", {
        responseType: "blob",
      })
      .then((response) => {
        const uri = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.download = name;
        link.href = uri;
        link.click();
      });

    const uri =
      `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_VER}` +
      this.RESOURCE +
      id +
      "/download";
    console.log(uri);
    const link = document.createElement("a");
    link.download = "photo.jpg";
    link.href = uri;
    link.click();
  }
}
